import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "./AuthContext";


const ProtectedRoute = ({ children, requiresSubscription = false }) => {
  const { isAuthenticated, isLoading, getUserPlan, isPlanLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <div>Loading...</div>;

  if (!isAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  if (requiresSubscription && isPlanLoading) {
    return <div>Checking subscription...</div>;
  }

  if (requiresSubscription && !getUserPlan()) {
    return <Navigate to="/subscribe" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
